module.exports = __webpack_public_path__ + "static/media/16.78519b11.png";